module.exports = __webpack_public_path__ + "img/COMBO TWIRL RED.2d1d106.svg";